import React, { Fragment } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav
} from "reactstrap";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";

const styleLink = {
  color:"black"
}

class MegaMenu extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      popoverOpen: false,
    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
      popoverOpen: !this.state.popoverOpen,
    });
  }
  state = {};
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyPress);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyPress);
  }
  handleKeyPress(event) {
    if (this.props.userInfo.userRole !== 'Administrator' && this.props.location.pathname !=='/UserAssessor/ReleaseLogs') {
      if (event.altKey && event.key.toLowerCase() === "s") {
        this.props.navigate('/DevelopmentAssessor');
      }
      if (event.altKey && event.key.toLowerCase() === "n") {
        this.props.navigate('/ProjectAssessor/Detail/00000000-0000-0000-0000-000000000000/00000000-0000-0000-0000-000000000000');
      }
    }
  }
  render() {
    return (
        <Fragment>
            {this.props.userInfo.userRole === 'Administrator' && <Fragment>
                <ul className="header-megamenu nav">
                    <li className="btn-group nav-item">
                        <a id="FinanceReportLink" className="nav-link" href="/Admin/FinanceReport" target="_blank">

                            <p style={{ marginTop: '15px' }}><i style={{marginRight:"5px"}} className="pe-7s-credit material-icons"></i>Finance Report</p>
                        </a>
                    </li>
                    <li className="btn-group nav-item">
                        <a id="PaymentLink" className="nav-link" href="/Admin/PaymentCredits">

                            <p style={{ marginTop: '15px' }}><i style={{marginRight:"5px"}} className="pe-7s-credit material-icons"></i>Payment</p>
                        </a>
                    </li>
                    <li className="btn-group nav-item">
                        <a id="RefundLink" className="nav-link" href="/Admin/PaymentRefunds">

                            <p style={{ marginTop: '15px' }}><i style={{marginRight:"5px"}} className="pe-7s-credit material-icons"></i>Refund</p>
                        </a>
                    </li>
                    <li className="btn-group nav-item">
                        <a id="CreditUnitLink" className="nav-link" href="/Admin/CreditUnits">

                            <p style={{ marginTop: '15px' }}><i style={{marginRight:"5px"}} className="pe-7s-credit material-icons"></i>Credit Units</p>
                        </a>
                    </li>
                    <li className="btn-group nav-item">
                        <a id="ProjectsLink" className="nav-link" href="/Admin/Developments">
                            {/* <i className="material-icons">build</i> */}
                            <p style={{ marginTop: '15px' }}> Developments </p>
                        </a>
                    </li>

                    <li className="btn-group nav-item">
                        <a id="ProjectsLink" className="nav-link" href="/Admin/Projects">
                            {/* <i className="material-icons">assignment</i> */}
                            <p style={{ marginTop: '15px' }}> Projects </p>
                        </a>
                    </li>

                    <li className="btn-group nav-item">
                        <a id="UsersLink" className="nav-link" href="/Admin/Users/">
                            {/* <i className="material-icons">person</i> */}
                            <p style={{ marginTop: '15px' }}><i className="pe-7s-user material-icons"></i> Users </p>
                        </a>
                    </li>
                </ul>
                <a className="btn btn-primary" href="/Admin/Users/Detail/00000000-0000-0000-0000-000000000000" target="_blank">Register User</a>
                <a style={{marginLeft:"15px"}} className="btn btn-primary" href="/Admin/SimulationByUserName" target="_blank">Simulation By Username</a>
            </Fragment>}
            {this.props.userInfo.userRole === 'AssessorBatch' && <>
              <ul className="header-megamenu nav">
                  <li className="btn-group nav-item">
                      <a id="CreditUnitLink" className="nav-link" href="/Admin/CreditUnits">
                          <p style={{ marginTop: '15px' }}><i style={{marginRight:"5px"}} className="pe-7s-albums material-icons"></i>Batch</p>
                      </a>
                  </li>
              </ul>
            </>}
        <Nav className="header-megamenu">
          {this.props.userInfo.userRole !== 'Administrator' && <Fragment>
              {/* <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav>
                  <u>L</u>ibraries
                  <FontAwesomeIcon className="ms-2 opacity-5" icon={faAngleDown} />
                </DropdownToggle>
                <DropdownMenu className="rm-pointers dropdown-menu">
                <DropdownItem>
                  <a style={styleLink} href="/LibraryAssessor/Constructions">
                    <u>C</u>onstructions
                  </a>
                </DropdownItem>
                <DropdownItem><u>S</u>hading schemes</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown> */}
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav>
                  <u>P</u>rojects
                  <FontAwesomeIcon className="ms-2 opacity-5" icon={faAngleDown} />
                </DropdownToggle>
                <DropdownMenu className="rm-pointers dropdown-menu">            
                  <DropdownItem>
                    <a style={styleLink} href="/ProjectAssessor/Detail/00000000-0000-0000-0000-000000000000/00000000-0000-0000-0000-000000000000">
                      <u>N</u>ew project&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a style={{color:"grey"}}>alt+n</a>
                    </a>      
                  </DropdownItem>
                  <DropdownItem>
                      <a style={styleLink} href="/DevelopmentAssessor">
                      <u>S</u>aved projects&nbsp;&nbsp;&nbsp;<a style={{color:"grey"}}>alt+s</a>
                    </a>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Fragment>}
        </Nav>
      </Fragment>
    );
  }
}
function WithNavigate(props) {
  let navigate = useNavigate();
  let location = useLocation();
  return <MegaMenu {...props} navigate={navigate} location={location} />;
}
export default WithNavigate;
